import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';


import './style.scss';

const ArticleTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'ArticleTeaser');
  const url = getPathFromAlternativePaths(entity, ['article', 'artikel']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="ArticleTeaser__content">
        <div className="ArticleTeaser__imageWrapper">
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'teaser_large'], '')}
            className="ArticleTeaser__imageNormal"
          />
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'large'], '')}
            className="ArticleTeaser__imageMobile"
          />
        </div>
        <div className="ArticleTeaser__contentWrapper">
          <div className="node--sub-heading node--sub-heading--with-labels">
            {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
              <div className="theme-labels">
                <div className="theme-label">
                  {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                </div>
                {entity.getIn(['field_theme']).size > 1 && (
                  <div className="theme-label">
                    +{entity.getIn(['field_theme']).size - 1}
                  </div>
                )}
              </div>
            ) : null}
            <span>{i18next.t('article')}</span>
          </div>
          <h3>{entity.getIn(['title', 0, 'value'])}</h3>
          {entity.getIn(['body', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default ArticleTeaser;
